import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
import { FormModal } from '@kwixeo/interface-vue'
import { AxiosResponse } from 'axios'
import { BFormGroup } from 'bootstrap-vue'
import { KForm, KFormInput } from '@kwixeo/form-vue'
import { mapActions } from 'vuex'
import { TranslateResult } from 'vue-i18n'
@Component({
  components: {
    FormModal,
    KForm, KFormInput,
    BFormGroup
  },
  methods: {
    ...mapActions('dashboard', ['setDashboard'])
  }
})
export default class DashboardForm extends Vue {
  setDashboard!: (dashboard: KwixeoDashboard.Dashboard) => void

  @Prop({ default: null }) value!: KwixeoDashboard.Dashboard
  @Prop({ default: false }) modal!: boolean

  private dashboard: KwixeoDashboard.DashboardForm = {}
  private modalState = false

  get formAction (): string {
    let url = '/dashboard'
    if (this.value?.id) {
      url += '/' + this.value.id
    }
    return url
  }

  get formMethod (): string {
    return this.value?.id ? 'PUT' : 'POST'
  }

  get modalTitle (): TranslateResult {
    return this.$t('dashboard.dashboard.' + (this.value?.id ? 'editTitle': 'addTitle'))
  }

  @Watch('modal', { immediate: true })
  private watchModal (state: boolean): void {
    this.modalState = state
    if (state) {
      this.watchValue(this.value)
    }
  }

  @Watch('value', { immediate: true })
  private watchValue (dashboard: KwixeoDashboard.Dashboard|null): void {
    this.dashboard = dashboard ? JSON.parse(JSON.stringify(dashboard)) : {}
  }

  @Emit('submitComplete')
  private formSubmitted (response: AxiosResponse): AxiosResponse {
    const dashboard = response.data
    this.setDashboard(dashboard)
    return dashboard
  }
}
